export type PasswordResetPathParts = {
  uidb64: string;
  token: string;
};

// The email link is `/accounts/password_reset/<uidb64>-<token>/`. Django's token
// itself contains a hyphen (`timestamp-hash`), so the token group must allow `-`
// but must never swallow the trailing slash — otherwise the token sent to the BFF
// no longer matches and the link is rejected as invalid.
const PASSWORD_RESET_PATH_PATTERN =
  /\/accounts\/password_reset\/([0-9A-Za-z]+)-([^/]+)\/?$/;

export function parsePasswordResetFromPath(
  pathname: string,
): PasswordResetPathParts {
  const match = pathname.match(PASSWORD_RESET_PATH_PATTERN);
  if (!match) {
    return { uidb64: "", token: "" };
  }
  return { uidb64: match[1], token: match[2] };
}
